"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var layout_utils_1 = require("../layout-utils");
var widget_model_1 = require("../../layout-models/widget.model");
var designer_layout_row_model_1 = require("../../layout-models/designer-layout-row.model");
var page_card_model_1 = require("../../layout-models/page-card.model");
var form_designer_constants_1 = require("../../components/designer/form/form-designer.constants");
var controller_drop_location_enum_1 = require("../../components/designer/form/controller-drop-location.enum");
var PageWidgetElement = /** @class */ (function () {
    function PageWidgetElement(domInfo) {
        this.domInfo = domInfo;
    }
    PageWidgetElement.prototype.onClone = function (pageContext) {
        pageContext.dragging = true;
        var widgetId = this.domInfo.getElemAttribute('widget_id');
        var colCount = this.domInfo.getElemColumnCount();
        var draggingElement = this.domInfo.getElem();
        var cloned = false;
        var animationIndex = 0;
        var offsetTop = 0;
        var offsetLeft = 0;
        function getCoordinates(mouseEvent) {
            offsetLeft = mouseEvent.clientX - draggingElement.offsetLeft;
            offsetTop = mouseEvent.clientY - draggingElement.offsetTop;
        }
        function animate() {
            animationIndex += 1;
        }
        if (widgetId) {
            var draggingCardTitle = void 0;
            var element_1 = document.createElement('div');
            var draggingCard_1 = document.querySelectorAll('.page-designer-card.gu-mirror .mat-card')[0];
            if (this.domInfo
                .getClasses()
                .contains('page-designer-card--tachometer')) {
                draggingCardTitle = document.querySelectorAll('.page-designer-card.gu-mirror .rc-gauge-toolbar__title')[0].textContent;
            }
            else if (this.domInfo
                .getClasses()
                .contains('page-designer-card--bar-chart')) {
                draggingCardTitle = document.querySelectorAll('.page-designer-card.gu-mirror .rc-chart-bar-toolbar__title')[0].textContent;
            }
            else if (this.domInfo.getClasses().contains('page-designer-card--list')) {
                draggingCardTitle = document.querySelectorAll('.page-designer-card.gu-mirror .rc-list-toolbar__title')[0].textContent;
            }
            else if (this.domInfo.getClasses().contains('page-designer-card--table')) {
                draggingCardTitle = document.querySelectorAll('.page-designer-card.gu-mirror .rc-table-toolbar__title')[0].textContent;
            }
            else if (this.domInfo
                .getClasses()
                .contains('page-designer-card--pie-chart')) {
                draggingCardTitle = document.querySelectorAll('.page-designer-card.gu-mirror .rc-chart-pie-toolbar__title')[0].textContent;
            }
            else if (this.domInfo.getClasses().contains('page-designer-card--map')) {
                draggingCardTitle = document.querySelectorAll('.page-designer-card.gu-mirror .rc-map-toolbar__title')[0].textContent;
            }
            draggingElement.appendChild(element_1);
            element_1.classList.add('page-designer-card__mirror');
            element_1.innerHTML = draggingCardTitle;
            draggingElement.onmousemove = function (mouseEvent) {
                var animationStart = 1;
                if (pageContext.itemInTrash) {
                    draggingElement.classList.add('page-designer-card--trash');
                }
                else {
                    draggingElement.classList.remove('page-designer-card--trash');
                }
                if (!cloned) {
                    getCoordinates(mouseEvent);
                    cloned = true;
                }
                if (animationIndex <= 20) {
                    element_1.style.width =
                        (280 - animationIndex * 2).toString() + 'px';
                    element_1.style.height =
                        (200 - animationIndex * 2).toString() + 'px';
                    animate();
                }
                if (offsetTop > 48) {
                    element_1.style.marginTop =
                        (offsetTop - (64 - animationIndex)).toString() + 'px';
                }
                if (offsetLeft > 48) {
                    element_1.style.marginLeft =
                        (offsetLeft - (64 - animationIndex)).toString() + 'px';
                    element_1.style.marginRight =
                        (offsetLeft - (64 - animationIndex)).toString() + 'px';
                }
                if (cloned && animationIndex <= animationStart * 2) {
                    if (animationIndex >= animationStart) {
                        var opacity = (animationIndex - animationStart) / animationStart;
                        draggingCard_1.style.opacity = (1 - opacity).toString();
                        element_1.style.opacity = opacity.toString();
                    }
                }
            };
        }
        else {
            this.domInfo.addClassToElem('page-designer-mirror--col-' + colCount);
            if (this.domInfo.getClasses() &&
                this.domInfo.getClasses().contains('gu-mirror')) {
                draggingElement.onmousemove = function (mouseEvent) {
                    if (pageContext.itemInTrash) {
                        draggingElement.classList.add('page-designer-mirror--trash');
                    }
                    else {
                        draggingElement.classList.remove('page-designer-mirror--trash');
                    }
                };
            }
        }
    };
    PageWidgetElement.prototype.onDrag = function (pageContext) {
        pageContext.showTrashBin = true;
        pageContext.widgetIdJustDropped = undefined;
    };
    PageWidgetElement.prototype.onDrop = function (pageContext) {
        if (this.newWidget()) {
            this.newWidgetDropped(pageContext);
        }
        else if (this.widgetReOrdered()) {
            this.widgetOrderAltered(pageContext);
        }
        else if (this.widgetInTrash()) {
            var rowId = this.domInfo.getSourceRowId();
            var cardId = this.domInfo.getElemAttribute('card_id');
            var widgetId = this.domInfo.getElemAttribute('widget_id');
            pageContext.checkIfWidgetSettingsOpened(widgetId);
            this.removeCardFromLayout(this.getFormRowById(rowId, pageContext), cardId, pageContext);
        }
    };
    PageWidgetElement.prototype.onHover = function (pageContext) {
        if (this.widgetInTrash()) {
            pageContext.itemInTrash = true;
        }
        else {
            pageContext.itemInTrash = false;
        }
        pageContext.hoveredRowId = this.domInfo.getContainerAttribute(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_ID_ATTRIBUTE);
        pageContext.beforeHoveredRowId = this.getBeforeRowId(pageContext.hoveredRowId, pageContext);
        pageContext.afterHoveredRowId = this.getAfterRowId(pageContext.hoveredRowId, pageContext);
        if (this.domInfo.itemInUpperRow()) {
            pageContext.newControllerDragLocation =
                controller_drop_location_enum_1.ControllerDropLocation.UPPER_PART;
        }
        else if (this.domInfo.itemInLowerRow()) {
            pageContext.newControllerDragLocation =
                controller_drop_location_enum_1.ControllerDropLocation.LOWER_ROW;
        }
        else if (this.domInfo.itemInRow()) {
            // to review
            pageContext.newControllerDragLocation =
                controller_drop_location_enum_1.ControllerDropLocation.IN_ROW;
        }
    };
    PageWidgetElement.prototype.removeCardFromLayout = function (row, cardId, pageContext) {
        var card = this.getPageCardById(cardId, pageContext);
        this.cleanLayout(row, cardId, pageContext);
        return card;
    };
    PageWidgetElement.prototype.getDroppedWidget = function (rowId, pageContext) {
        if (this.domInfo.itemInUpperRow() &&
            pageContext.widgetUpperRowBagModels.length > 0) {
            return pageContext.widgetUpperRowBagModels.find(function (item) { return !item.checkedInLayout; });
        }
        else if (this.domInfo.itemInRow() &&
            pageContext.widgetRowBagModels.get(rowId)) {
            return pageContext.widgetRowBagModels
                .get(rowId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        else if (this.domInfo.itemInLowerRow() &&
            pageContext.widgetLowerRowBagModels.get(rowId)) {
            return pageContext.widgetLowerRowBagModels
                .get(rowId)
                .find(function (item) { return !item.checkedInLayout; });
        }
    };
    PageWidgetElement.prototype.cleanLayout = function (row, cardId, pageContext) {
        var cardIndex = row.cards.findIndex(function (item) {
            return item.id === cardId;
        });
        row.cards.splice(cardIndex, 1);
        if (!this.checkIfRowNotEmpty(row)) {
            var rowIndex = pageContext.layout.layoutRows.findIndex(function (item) {
                return item.id === row.id;
            });
            pageContext.layout.layoutRows.splice(rowIndex, 1);
        }
    };
    PageWidgetElement.prototype.widgetOrderAltered = function (pageContext) {
        var sourceRowId = this.domInfo.getSourceRowId();
        var destinationRowId = this.domInfo.getDestinationRowId();
        var cardId = this.domInfo.getElemAttribute('card_id');
        var reOrderedCard = this.removeCardFromLayout(this.getFormRowById(sourceRowId, pageContext), cardId, pageContext);
        var droppedWidget = reOrderedCard.widgets[0];
        if (this.domInfo.itemInRow()) {
            var indexInRow = this.getIndexInRow(destinationRowId, droppedWidget, pageContext);
            var row = pageContext.layout.layoutRows.find(function (roww) { return roww.id === destinationRowId; });
            row.insertCardOnIndex(reOrderedCard, indexInRow);
        }
        else if (this.domInfo.itemInLowerRow()) {
            var rowWhereNewWidgetDropped = pageContext.layout.insertInLowerRow(destinationRowId);
            pageContext.newCreatedRowId = rowWhereNewWidgetDropped.id;
            rowWhereNewWidgetDropped.addCard(reOrderedCard);
            var item = pageContext.widgetLowerRowBagModels.get(destinationRowId)[0];
            pageContext.widgetRowBagModels.set(rowWhereNewWidgetDropped.id, [
                item,
            ]);
            pageContext.widgetLowerRowBagModels.set(rowWhereNewWidgetDropped.id, []);
            pageContext.widgetLowerRowBagModels.set(destinationRowId, []);
        }
        else if (this.domInfo.itemInUpperRow()) {
            var rowWhereNewWidgetDropped = pageContext.layout.insertInUpperRow();
            pageContext.newCreatedRowId = rowWhereNewWidgetDropped.id;
            rowWhereNewWidgetDropped.addCard(reOrderedCard);
            var leaf = pageContext
                .widgetUpperRowBagModels[0];
            pageContext.widgetRowBagModels.set(rowWhereNewWidgetDropped.id, [
                leaf,
            ]);
            pageContext.widgetLowerRowBagModels.set(rowWhereNewWidgetDropped.id, []);
            pageContext.widgetUpperRowBagModels = [];
        }
        pageContext.handleWidgetViewContainer(droppedWidget);
    };
    PageWidgetElement.prototype.checkIfRowNotEmpty = function (row) {
        return row.cards && row.cards.length > 0;
    };
    PageWidgetElement.prototype.getFormRowById = function (rowId, pageContext) {
        return pageContext.layout.layoutRows.find(function (layoutRow) {
            return layoutRow.id === rowId;
        });
    };
    PageWidgetElement.prototype.getPageCardById = function (cardId, pageContext) {
        var desiredCard;
        pageContext.layout.layoutRows.forEach(function (layoutRow) {
            if (layoutRow.cards.some(function (card) { return card.id === cardId; })) {
                desiredCard = layoutRow.cards.find(function (card) { return card.id === cardId; });
            }
        });
        return desiredCard;
    };
    PageWidgetElement.prototype.newWidgetDropped = function (pageContext) {
        var rowId = this.domInfo.getDestinationRowId();
        var newDragged = this.getDroppedWidget(rowId, pageContext);
        // const droppedItemIndex = pageContext.layoutWidgets.findIndex(item => !item.checkedInLayout);
        if (newDragged) {
            newDragged.checkedInLayout = true;
            newDragged.id = layout_utils_1.LayoutUtils.uniqueId();
            var droppedWidget = new widget_model_1.WidgetModel(newDragged.id, newDragged.meta);
            var pageCard = this.getNewPageCard();
            pageCard.columnCount = newDragged.meta.columnCount;
            pageCard.height = newDragged.meta.height;
            if (this.domInfo.itemInRow()) {
                var indexInRow = this.getIndexInRow(rowId, droppedWidget, pageContext);
                var row = pageContext.layout.layoutRows.find(function (roww) { return roww.id === rowId; });
                row.insertCardOnIndex(pageCard, indexInRow);
            }
            else if (this.domInfo.itemInLowerRow()) {
                var rowWhereNewWidgetDropped = pageContext.layout.insertInLowerRow(rowId);
                pageContext.newCreatedRowId = rowWhereNewWidgetDropped.id;
                rowWhereNewWidgetDropped.addCard(pageCard);
                var item = pageContext.widgetLowerRowBagModels.get(rowId)[0];
                pageContext.widgetRowBagModels.set(rowWhereNewWidgetDropped.id, [item]);
                pageContext.widgetLowerRowBagModels.set(rowWhereNewWidgetDropped.id, []);
                pageContext.widgetLowerRowBagModels.set(rowId, []);
            }
            else if (this.domInfo.itemInUpperRow()) {
                var rowWhereNewWidgetDropped = pageContext.layout.insertInUpperRow();
                pageContext.newCreatedRowId = rowWhereNewWidgetDropped.id;
                rowWhereNewWidgetDropped.addCard(pageCard);
                var leaf = pageContext
                    .widgetUpperRowBagModels[0];
                pageContext.widgetRowBagModels.set(rowWhereNewWidgetDropped.id, [leaf]);
                pageContext.widgetLowerRowBagModels.set(rowWhereNewWidgetDropped.id, []);
                pageContext.widgetUpperRowBagModels = [];
            }
            pageCard.addWidget(droppedWidget);
            pageContext.widgetIdJustDropped = droppedWidget.id;
            pageContext.handleWidgetViewContainer(droppedWidget);
        }
    };
    PageWidgetElement.prototype.getBeforeRowId = function (rowId, pageContext) {
        var index = pageContext.layout.layoutRows.findIndex(function (row) { return row.id === rowId; }) -
            1;
        if (index >= 0) {
            return pageContext.layout.layoutRows[index].id;
        }
        return undefined;
    };
    PageWidgetElement.prototype.getAfterRowId = function (rowId, pageContext) {
        var index = pageContext.layout.layoutRows.findIndex(function (row) { return row.id === rowId; }) -
            1;
        if (index > -1 && index < pageContext.layout.layoutRows.length) {
            return pageContext.layout.layoutRows[index].id;
        }
        return undefined;
    };
    PageWidgetElement.prototype.getIndexInRow = function (rowId, droppedWidget, pageContext) {
        var indexInRow = 0;
        if (this.domInfo.itemInRow() &&
            pageContext.widgetRowBagModels.get(rowId)) {
            indexInRow = pageContext.widgetRowBagModels
                .get(rowId)
                .findIndex(function (item) { return !item.checkedInLayout; });
            if (indexInRow < 0) {
                indexInRow = pageContext.widgetRowBagModels
                    .get(rowId)
                    .findIndex(function (item) { return item.id === droppedWidget.id; });
            }
        }
        return indexInRow;
    };
    PageWidgetElement.prototype.getNewPageCard = function () {
        var card = new page_card_model_1.PageCardModel();
        card.id = layout_utils_1.LayoutUtils.uniqueId();
        return card;
    };
    PageWidgetElement.prototype.getLayoutRowForNewWidget = function (droppedItemIndex, pageContext) {
        var row = new designer_layout_row_model_1.DesignerLayoutRowModel();
        row.id = layout_utils_1.LayoutUtils.uniqueId();
        pageContext.layout.insertRowOnIndex(row, droppedItemIndex);
        return row;
    };
    PageWidgetElement.prototype.widgetInTrash = function () {
        return this.domInfo.containerIdEquals(PageWidgetElement.WIDGET_TRASH_BIN_DOM_ID);
    };
    PageWidgetElement.prototype.newWidget = function () {
        return !this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER);
    };
    PageWidgetElement.prototype.widgetReOrdered = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER) &&
            !this.domInfo.containerIdEquals(PageWidgetElement.WIDGET_TRASH_BIN_DOM_ID));
    };
    PageWidgetElement.WIDGET_TRASH_BIN_DOM_ID = 'trash_bin';
    PageWidgetElement.CARDS_CONTAINER_DOM_ID = 'cards-container';
    PageWidgetElement.WIDGET_UPPER_ROW = 'widget-upper-row';
    PageWidgetElement.WIDGET_LOWER_ROW = 'widget-lower-row';
    PageWidgetElement.WIDGET_ROW = 'widget-row';
    return PageWidgetElement;
}());
exports.PageWidgetElement = PageWidgetElement;
//# sourceMappingURL=page-widget.element.js.map